export const LOGO_WORDMARK = "/logo-wordmark.png";
export const LOGO_CRESCENT = "/logo-crescent.png";
export const BANNER = "/banner-v3.webp";
export const POSTER = "/poster-v3.jpg";

export const SIZES = ["S", "M", "L", "XL", "2XL", "3XL"];

export const CATEGORIES = [
  { id: "all", label: "All Pieces" },
  { id: "hoodie-sets", label: "Hoodie Sets" },
  { id: "sister-sets", label: "Sister Hoodie Sets" },
  { id: "jacket", label: "Jacket" },
  { id: "shorts", label: "Shorts" },
  { id: "shirts", label: "Shirts" },
  { id: "accessories", label: "Accessories" },
];

const setOptions = (prefix, setPrice, hoodiePrice, pantsPrice) => [
  { id: "set", label: "Full Set", sub: "Hoodie + Pants", lookupKey: `${prefix}_set`, price: setPrice, sized: true },
  { id: "hoodie", label: "Hoodie Only", sub: "Sold separately", lookupKey: `${prefix}_hoodie`, price: hoodiePrice, sized: true },
  { id: "pants", label: "Pants Only", sub: "Sold separately", lookupKey: `${prefix}_pants`, price: pantsPrice, sized: true },
];

export const SIZE_CHART = {
  hoodie: {
    title: "Hoodie",
    cols: ["Chest", "Length", "Sleeve"],
    rows: { S: ["44", "27", "24"], M: ["46", "28", "24.5"], L: ["48", "29", "25"], XL: ["50", "30", "25.5"], "2XL": ["52", "31", "26"], "3XL": ["54", "32", "26.5"] },
  },
  pants: {
    title: "Sweatpants",
    cols: ["Waist", "Inseam", "Length"],
    rows: { S: ["28–30", "29", "40"], M: ["31–33", "30", "41"], L: ["34–36", "30.5", "42"], XL: ["37–39", "31", "43"], "2XL": ["40–42", "31.5", "44"], "3XL": ["43–45", "32", "45"] },
  },
};
